import { Component, OnInit } from '@angular/core';
import { SlokaTypeLogicService } from '../../logic/sloka-type.service';
import { AddSlokaTypeModel } from '../../interfaces/interfaces';
import { first, switchMap, mergeAll, map } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { PassDataService } from '../../services/pass-data.service';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { DashboardLogicService } from '../../logic/dashboard.service';

@Component({
  selector: 'add-sloka-type-pg',
  templateUrl: './add-sloka-type.component.html',
})
export class AddSlokaTypePage implements OnInit {
  title: string = '';
  description: string = '';
  imageUrl: string = '';
  _id: string = '';
  private file: any = null;
  state: any = '';
  isViewImage: boolean = true;

  constructor(
    private slokaTypeLogicService: SlokaTypeLogicService,
    private passDataService: PassDataService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.state = window.history.state;
    if (this.state.data) {
      (this.state.isEdit || this.state.isView) &&
        (this.title = this.state.data.title) &&
        (this.description = this.state.data.description) &&
        (this._id = this.state.data._id);
    }
  }

  imageFileOutput(file: any) {
    this.file = file;
  }

  setTitle(title: string) {
    this.title = title;
  }

  setDescription(description: string) {
    this.description = description;
  }

  onAddClick() {
    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Adding sloka type, please wait!',
    });

    if (this.file == null || this.title == '') {
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Title and image fields are mandotary',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
      return;
    }

    this.slokaTypeLogicService
      .addSlokaTypeLogic(
        this.title,
        this.description,
        this.file != null ? this.file.item(0) : null
      )
      .subscribe((v: any) => {
        this.router.navigate(['/page/sloka-types-list']);
        this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

        this.passDataService.setPopup({
          isPopup: true,
          message: v.message,
          isOk: true,
          isDelete: false,
          isLoading: false,
          loadingMessage: '',
        });
      });
  }

  onEditClick() {
    this.state.isEdit = !this.state.isEdit;
    this.state.isView = !this.state.isView;
  }

  onUpdateClick() {
    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Updating sloka type, please wait!',
    });

    if (this.title == '' || this.description == '') {
      this.passDataService.setPopup({
        isPopup: true,
        message: 'All Fields are mandotary!',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
      return;
    }

    this.slokaTypeLogicService
      .updateSlokaTypeLogic(
        this.title,
        this.description,
        this.file != null ? this.file.item(0) : null,
        this.state.data.imageUrl,
        this.state.data.id
      )
      .subscribe((v: any) => {
        this.router.navigate(['/page/sloka-types-list']);
        this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

        this.passDataService.setPopup({
          isPopup: true,
          message: v.message,
          isOk: true,
          isDelete: false,
          isLoading: false,
          loadingMessage: '',
        });
      });
  }
}
